"use client"
import { Link } from "react-router-dom"

const PendingTasksTable = ({ dashboards }) => {
  return (
    <div className="card enhanced-table-card">
      <div className="card-header enhanced-table-header">
        <div className="d-flex align-items-center justify-content-between">
          <div className="d-flex align-items-center">
            <i className="fas fa-tasks me-2 text-warning"></i>
            <strong>Pending Tasks</strong>
          </div>
          <div className="table-actions">
            <Link to="/activitys" className="btn btn-sm btn-outline-primary">
              View All
            </Link>
          </div>
        </div>
      </div>
      <div className="card-body p-0">
        <div className="table-responsive">
          <table className="table enhanced-table mb-0">
            <thead>
              <tr>
                <th style={{ width: "60px" }}>Sr No</th>
                <th>Client Name</th>
                <th>Task Name</th>
                <th>Process</th>
                <th>Assigned To</th>
                <th>Status</th>
                <th style={{ width: "80px" }}>Action</th>
              </tr>
            </thead>
            <tbody>
              {dashboards &&
                dashboards.activities &&
                dashboards.activities.slice(0, 100).map((item, index) => (
                  <tr key={index}>
                    <td className="text-center">
                      <span className="row-number">{index + 1}</span>
                    </td>
                    <td>
                      <div className="client-info">
                        <span className="client-name">{item.client && item.client.name}</span>
                      </div>
                    </td>
                    <td>
                      <div className="task-info">
                        <span className="task-name">{item.task_name}</span>
                      </div>
                    </td>
                    <td>
                      <span className="process-badge">{item.process && item.process.name}</span>
                    </td>
                    <td>
                      <div className="assignee-info">
                        <span className="assignee-name">{item.assigned_to && item.assigned_to.name}</span>
                      </div>
                    </td>
                    <td>
                      <span className="status-badge">{item.activity_status && item.activity_status.name}</span>
                    </td>
                    <td className="text-center">
                      <Link to={`/activitys/${item._id}/view`} className="btn btn-sm btn-outline-info action-btn">
                        <i className="fas fa-eye"></i>
                      </Link>
                    </td>
                  </tr>
                ))}
              {(!dashboards || !dashboards.activities || dashboards.activities.length === 0) && (
                <tr>
                  <td colSpan="7" className="text-center py-4">
                    <div className="no-data">
                      <i className="fas fa-inbox text-muted mb-2"></i>
                      <p className="text-muted mb-0">No pending tasks found</p>
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      <style jsx>{`
        .enhanced-table-card {
          border: 1px solid #e3e9f3;
          border-radius: 12px;
          box-shadow: rgb(227 233 243) 0px 4px 22px;
          margin-bottom: 25px;
          background: #fff;
        }

        .enhanced-table-header {
          background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
          border-bottom: 1px solid #e3e9f3;
          padding: 16px 20px;
          font-size: 14px;
          font-weight: 600;
          color: #495057;
          border-radius: 12px 12px 0 0;
        }

        .table-actions .btn {
          font-size: 12px;
          padding: 6px 16px;
          border-radius: 6px;
        }

        .enhanced-table {
          font-size: 12px;
          margin: 0;
        }

        .enhanced-table thead th {
          background: #f8f9fa;
          border-bottom: 2px solid #e3e9f3;
          color: #495057;
          font-weight: 600;
          font-size: 12px;
          padding: 16px 12px;
          vertical-align: middle;
          position: sticky;
          top: 0;
          z-index: 10;
        }

        .enhanced-table tbody tr {
          border-bottom: 1px solid #f1f3f4;
          transition: background-color 0.2s ease;
        }

        .enhanced-table tbody tr:hover {
          background-color: #f8f9fa;
        }

        .enhanced-table tbody tr:nth-child(even) {
          background-color: #fdfdfd;
        }

        .enhanced-table tbody tr:nth-child(even):hover {
          background-color: #f8f9fa;
        }

        .enhanced-table tbody td {
          padding: 14px 12px;
          vertical-align: middle;
          border-bottom: 1px solid #f1f3f4;
        }

        .row-number {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          width: 28px;
          height: 28px;
          background: #e9ecef;
          border-radius: 50%;
          font-size: 11px;
          font-weight: 600;
          color: #495057;
        }

        .client-info, .task-info, .assignee-info {
          display: flex;
          flex-direction: column;
        }

        .client-name, .task-name, .assignee-name {
          font-weight: 500;
          color: #495057;
          line-height: 1.3;
          max-width: 150px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .process-badge, .status-badge {
          display: inline-block;
          padding: 4px 10px;
          border-radius: 14px;
          font-size: 11px;
          font-weight: 500;
          background: #e9ecef;
          color: #495057;
          max-width: 120px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .status-badge {
          background: #d4edda;
          color: #155724;
        }

        .action-btn {
          padding: 6px 10px;
          font-size: 11px;
          border-radius: 6px;
        }

        .no-data {
          padding: 30px;
          text-align: center;
        }

        .no-data i {
          font-size: 24px;
          display: block;
        }

        @media (max-width: 768px) {
          .enhanced-table-header {
            padding: 12px 16px;
          }
          
          .enhanced-table thead th,
          .enhanced-table tbody td {
            padding: 10px 8px;
          }
          
          .client-name, .task-name, .assignee-name {
            max-width: 100px;
          }
        }
      `}</style>
    </div>
  )
}

export default PendingTasksTable
